<div class="kp-dialog__container">
  <div class="kp-dialog__header">{{title}}</div>
  <div class="kp-dialog__body">
    <ng-content></ng-content>
  </div>
  <div class="kp-dialog__footer"></div>
</div>
